import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../redux/stateHooks";
import { resetState } from "../../redux/store";
import {
  getFromStorage,
  removeAllFromStorage,
  saveOnConfigFile,
} from "../../utils/helpers";
import ExportSetting from "./exportSetting";
import FolderSetting from "./folderSetting";
import MergeSetting from "./mergeSetting";
import MergeTypeSetting from "./mergeTypeSetting";
import UserSetting from "./userSetting";
import { useState } from "react";
import { LocalStorageKeys } from "../../utils/constant";
import { useLocalStorage } from "../../hooks/useLocalStorage";

function Settings() {
  const [enableSaveButton, setEnableSaveButton] = useState(false);
  const [config] = useLocalStorage(LocalStorageKeys.CONFIG, null);
  const [mergeSetting, setMergeSetting] = useState<"DATA_MERGE" | "XML_MERGE">(
    config?.mergeStyle
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const handleLogout = () => {
    removeAllFromStorage();
    dispatch(resetState());
    navigate("/login");
  };

  const handleUpdateConfig = async () => {
    setEnableSaveButton(false);
    let config = getFromStorage(LocalStorageKeys.CONFIG);
    if (!config) {
      await saveOnConfigFile(LocalStorageKeys.CONFIG, {
        mergeStyle: mergeSetting,
      });
    } else {
      // update merge style.....
      config.mergeStyle = mergeSetting;
      await saveOnConfigFile(LocalStorageKeys.CONFIG, config);
    }

    // Update
  };

  return (
    <div>
      <div className="tab-pane custom-tabPane2">
        <div className="cnt-space">
          <div className="leftside sameheight">
            <UserSetting />
            {/* <MergeSetting /> */}
            <MergeTypeSetting
              mergeSetting={mergeSetting}
              setMergeSetting={setMergeSetting}
              setEnableSaveButton={setEnableSaveButton}
            />
            {/* <ExportSetting /> */}
            <FolderSetting />
          </div>
          <div className="rightside text-right right-action sameheight">
            <button
              className={`btn btn-primary ${enableSaveButton ? "active" : ""}`}
              type="button"
              disabled={!enableSaveButton}
              onClick={handleUpdateConfig}
            >
              Save
            </button>
            {/* <button className="btn btn-primary" type="button">
              Setup Users
            </button> */}
            <button
              className="btn btn-primary btnlogout"
              type="button"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings;
